import React, { FC, useState, useEffect, useCallback } from 'react'
import { observer } from 'mobx-react'
import { classNames } from '@dt/fe-utils'
import { cartMobx } from 'restaurant'
import CashierController from 'controllers/cashierController'
import { Price, ProductImage, Stepper } from '@cps'
import './index.scss'

// interface
interface IProps {
  product: IOrderSwapBuyProduct;
  disabled: boolean;
  count?: number;
}

const ProductItem: FC<IProps> = ({ product, disabled, count = 0 }) => {
  const [defaultImg, setDefault] = useState<string>('')

  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]')
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : product.pic) : product.pic
    setDefault(defaultImgUrl)
  }, [product])

  const handleClick = () => {
    if (disabled) return
    CashierController.handleProductToCart({
      type: 'add',
      product,
      isAddProduct: true,
      isOrderSwapBuy: true
    })
  }

  const handleChangeCnt = useCallback((isAdd: boolean, event: React.MouseEvent) => {
    event.stopPropagation()
    if (disabled) return
    CashierController.handleProductToCart({
      type: isAdd ? 'add' : 'minus',
      product,
      isAddProduct: true,
      isOrderSwapBuy: true
    })
  }, [count, disabled, product])

  return (
    <div
      className={classNames('dosb-product-item', { disabled: disabled })}
      data-cypid={`discountProductItem_no_${product.no}`}
      onClick={handleClick}
    >
      <ProductImage width={140} height={100} imgSrc={defaultImg} />
      <div className='product-info'>
        <div className='product-name'>{product.name}</div>
        <div className='product-actions'>
          <Price
            className='product-price'
            price={product.price}
            actualPrice={product.actualPrice}
            hideMarketPrice={false}
            soldOut={false}
            offPrice={product.offPrice}
            memberPrice={product.memberPrice}
            isMemberDiscount={product.isMemberDiscount}
          />
          <Stepper uid={'dosb' + product.no} cnt={count} onChange={handleChangeCnt} hideMinus={count === 0} disabled={cartMobx.info.eatType !== 'dinein' && !product.isCanTogo} />
        </div>
      </div>
    </div>
  )
}
export default observer(ProductItem)
